import '@angular/localize/init';
export * from './lib/feature-tax-dividend-list.module';

export * from './lib/tax-dividend-list/feature-tax-dividend-list.component';
